import * as React from "react";
import styled from "styled-components/native";

import useSignOut from "../../auth/useSignOut";
import {
  AlignItems,
  background,
  Divider,
  Info,
  JustifyContent,
  Label,
  LayoutRow,
  Space,
  spacing,
} from "../../styled-component";
import { Theme } from "../../styles";
import AppContextSwitcher from "../../app-context/AppContextSwitcher";

import Modal from "./Modal";
import CurrentUser from "./CurrentUser";
import Button from "./PressableButton";
import { useNavigation, useRoute } from "@react-navigation/native";
import { get, snakeCase, startCase } from "lodash";
import useAppContextRole from "../../app-context/useAppContextRole";
import { RootTabParamList } from "../../types";
import AppContext from "../../app-context/AppContext";

const AppBarContainer = styled(LayoutRow).attrs({
  background: Theme.colors.background,
})`
  ${background};

  border-color: ${Theme.colors.backgroundDivider};
  border-bottom-width: ${Theme.borderThickness}px;
  border-style: solid;
  align-items: center;
  /* justify-content: space-between; */
`;

const navOptions = [
  "videos",
  "moves",
  // "families",
  // "syllabi",
  // "view syllabi",
  "classes",
].reverse();
// const navOptions = ["classes", "moves"];

import ToggleInput from "./ToggleInput";
import IconButton from "../../common/components/IconButton";
import CreateOrUpdateVideo from "../video/CreateOrUpdateVideo";
import CreateOrUpdateMove from "../move/CreateOrUpdateMove";
import Routes from "../../navigation/Routes";
import CreateOrUpdateClazz from "../clazz/CreateOrUpdateClazz";
import Layout from "./Layout";
import JoinClass from "../../clazzes/JoinClazz";

export interface AppBarProps {}

function AppBar({}: AppBarProps) {
  const route = useRoute();
  const [role] = useAppContextRole();
  const [isVisible, setIsVisible] = React.useState(false);
  const signOut = useSignOut();
  const [selectedNavOption, setSelectedNavOption] = React.useState<string>(
    snakeCase(get(route, ["state", "routes", 0, "name"])).replace("_", " ")
  );

  const currentUser = (
    <CurrentUser>
      <Label>{role}</Label>
    </CurrentUser>
  );

  const navigation = useNavigation();

  const open = () => setIsVisible(true);

  const dismiss = () => setIsVisible(false);

  const navigate = (option: string) => {
    const screen = startCase(option).replace(
      /\s+/g,
      ""
    ) as keyof RootTabParamList;

    navigation.navigate("Root", {
      screen,
    });
  };

  React.useEffect(() => {
    if (!role) {
      setIsVisible(true);
    }
  }, [role]);

  return (
    <>
      <AppBarContainer>
        <Layout.Column greedy>
          <Space />

          <Layout.Row>
            <Button onPress={open}>{currentUser}</Button>

            <Info greedy justifyContent={JustifyContent.Center}>
              <Layout.Row
                // greedy
                justifyContent={JustifyContent.SpaceBetween}
                alignItems={AlignItems.Center}
              >
                <ToggleInput
                  value={selectedNavOption}
                  options={navOptions}
                  onChange={(navOption) => {
                    setSelectedNavOption(navOption);

                    navigate(navOption);
                  }}
                />

                <Layout.Row>
                  <AppContext.Instructor>
                    <Routes.Moves>
                      <CreateOrUpdateMove>
                        {({ onPress }) => (
                          <Button
                            title="Create Move"
                            mode="contained"
                            onPress={onPress}
                          />
                        )}
                      </CreateOrUpdateMove>
                    </Routes.Moves>

                    <Routes.Videos>
                      <CreateOrUpdateVideo>
                        {({ onPress }) => (
                          <Button
                            title="Create Video"
                            mode="contained"
                            onPress={onPress}
                          />
                        )}
                      </CreateOrUpdateVideo>
                    </Routes.Videos>
                  </AppContext.Instructor>

                  <Space />
                </Layout.Row>
              </Layout.Row>
            </Info>
          </Layout.Row>

          <Space />
        </Layout.Column>

        <Space />
      </AppBarContainer>

      <Modal
        isVisible={isVisible}
        isDismissable={role !== undefined}
        onDismiss={dismiss}
        primaryAction={
          <Button
            title="sign out"
            color="accent"
            mode="contained"
            onPress={signOut}
          />
        }
        secondaryAction={
          <Modal.DismissButton
            title="done"
            mode="outlined"
            disabled={!role}
            onPress={dismiss}
          />
        }
        content={
          <Modal.Content>
            {currentUser}

            <Space />

            <Divider />

            <Space />

            <AppContextSwitcher onPress={() => setIsVisible(false)} />
          </Modal.Content>
        }
      />
    </>
  );
}

export default AppBar;
